<div class="video-card bg-surface-100 dark:bg-surface-600" [ngClass]="{ 'video-card-preview': previewMode() }">
  <div class="content">
    <app-video-player
      [conversationId]="conversationId()"
      [attachmentId]="attachmentId()"
      [currentTabIndex]="currentTabIndex()"
    >
    </app-video-player>
  </div>
  <div class="header">
    <div class="icon">
      <i class="mi2-video-fileshare text-[36px] text-surface-950 dark:text-surface-0"></i>
    </div>
    <div class="information">
      <span class="title">
        {{ attachmentName() }}
      </span>
      <span class="size">
        {{ attachmentSize() }}
      </span>
    </div>
  </div>
</div>
